export default {"src":"/_next/static/media/leafygreen.b4b562f0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};